import dayjs from 'dayjs'
const msgTypeMaps = {
  TIMTextElem: 'text',
  TIMImageElem: 'image',
}
const imMsgObjToLocalMsgObj = function(msg) {
  let localMsg = {
    id: msg.ID,
    source: msg.flow,
    type: msgTypeMaps[msg.type],
    time: dayjs(msg.time * 1000).format('HH:MM:ss'),
  }
  if (msgTypeMaps[msg.type] === 'text') {
    localMsg.value = msg.payload.text
  } else if (msgTypeMaps[msg.type] === 'image') {
    localMsg.value = msg.payload.imageInfoArray[0].url
  }
  return localMsg
}

export { imMsgObjToLocalMsgObj }
